import { useContext, createContext, ReactNode } from 'react';
import validateEmail from 'lib/validateEmail';
import validatePhone from 'lib/validatePhone';
import { EmailValidator, PhoneValidator } from 'types/Validators';
import { curry } from 'lodash';
import useConfig from './useConfig';

export interface ValidationInterface {
  validateEmail: EmailValidator;
  validatePhone: PhoneValidator;
}

const ValidationContext = createContext<ValidationInterface>(
  // in practice this will never be empty, can't figure out how to tell TS that
  {} as ValidationInterface
);

interface ValidationProviderProps {
  children: ReactNode;
  validateEmail?: EmailValidator;
  validatePhone?: PhoneValidator;
}

export function ValidationProvider({
  children,
  validateEmail: providedValidateEmail,
  validatePhone: providedValidatePhone,
}: ValidationProviderProps): JSX.Element {
  const { configs } = useConfig();

  const emailValidationValue = {
    validateEmail: providedValidateEmail ?? curry(validateEmail)(configs.emailValidatorUrl),
    validatePhone: providedValidatePhone ?? curry(validatePhone)(configs.phoneValidatorUrl),
  };

  return (
    <ValidationContext.Provider value={emailValidationValue}>{children}</ValidationContext.Provider>
  );
}

export function useValidation(): ValidationInterface {
  return useContext(ValidationContext);
}
